import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Address');

const propTypes = {
    messages: PropTypes.shape({
        address: PropTypes.shape({
            primaryInfo: PropTypes.func,
        }),
    }),
    personTitle: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    addressLine: PropTypes.arrayOf(PropTypes.string),
    city: PropTypes.string,
    zipCode: PropTypes.string,
    country: PropTypes.string,
    state: PropTypes.string,
    phone1: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    countryName: PropTypes.string,
    stateName: PropTypes.string,
    countryCode: PropTypes.string,
};

const defaultProps = {
    personTitle: '',
    firstName: '',
    lastName: '',
    addressLine: [],
    city: '',
    zipCode: '',
    country: '',
};

function Address(props) {
    const {
        personTitle,
        firstName,
        lastName,
        pronunciations,
        addressLine,
        city,
        zipCode,
        state: stateCode,
        country,
        countryCode,
        countryName: countryFullName,
        className,
        children,
        stateName: stateFullName,
    } = props;
    const countryModifier = countryCode ? countryCode : country;
    const stateName = stateFullName || stateCode;
    const countryName = countryFullName || country;

    return (
        <div className={bem(null, null, className)}>
            <div className={bem('fields')}>
                {pronunciations?.[0]?.lastName ? (
                    <div className={bem('pronunciationName')}>{`${pronunciations[0]?.lastName} ${pronunciations[0]?.firstName}`}</div>
                ) : null}
                <div className={bem('name', countryModifier)}>
                    <li className={bem('firstName', countryModifier)}>{`${personTitle} ${firstName}`}</li>
                    <li className={bem('lastName', countryModifier)}>{lastName}</li>
                </div>
                {addressLine.map((address, i) => (
                    <div key={i} className={bem(`line${i}`, countryModifier)}>
                        {address}
                    </div>
                ))}
                {city && <div className={bem('city', countryModifier)}>{city}</div>}
                {stateName && <div className={bem('state', countryModifier)}>{stateName}</div>}
                {zipCode && <div className={bem('zipCode', countryModifier)}>{zipCode}</div>}
                {countryName && <div className={bem('country', countryModifier)}>{countryName}</div>}
            </div>
            {children ? <div className={bem('content')}>{children}</div> : null}
        </div>
    );
}

Address.propTypes = propTypes;
Address.defaultProps = defaultProps;

export default Address;
